import { MappingData, ServerResponse } from '@/types';

export type MappingDataResponse = ServerResponse<MappingData>;

export enum MappingAction {
  addNewProduct = 'addNewProduct',
  uploadFile = 'uploadFile',
  filterByMappingStatus = 'filterByMappingStatus',
  editMode = 'editMode',
}

export enum ShareLoanColumns {
  select = 'select',
  typeCode = 'typeCode',
  type = 'type',
  typeCodeDesc = 'typeCodeDesc',
}

export enum MappingOrderProperty {
  type = 'type',
  typeCode = 'typeCode',
}
